<template>
    <div>
        <span v-if="isMsgTextWithoutPlaceholder" v-html="msgText" >

        </span>
        <span v-else>
                <span v-html="msgTextBeforePlaceholder">
                    {{docCode}}
                </span>
                <span
                    :class="{
                        'color-primary cursor-pointer': isDocAppProperty
                    }"
                    @click="openDocPopup(docCode)"
                    v-html="msgTextInPlaceholder">
                </span>
                <span v-html="msgTextAfterPlaceholder">

                </span>
        </span>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "MessageReceivedContent",

    props: {
        msgText : {
            type: String,
            required: true,
            default: ''
        }
    },

    computed :{

        ...mapGetters({
            getAppPropertyValue : 'TranslationStore/getAppPropertyValue'
        }),

        docCode() {
            return this.placeholderBegin.match("[1-9]");
        },

        isDocAppProperty() {
            return this.getAppPropertyValue("DOC_PFI_ADDRESS_" + this.docCode) !== null;
        },

        placeholderBegin() {
            if (this.msgText.match("%%DOC_PFI_[1-9]_BEGIN%%")) {
                return this.msgText.match("%%DOC_PFI_[1-9]_BEGIN%%")[0]
            }
        },

        placeholderEnd() {
            if (this.msgText.match("%%DOC_PFI_[1-9]_BEGIN%%")) {
                return this.msgText.match("%%DOC_PFI_[1-9]_END%%")[0];
            }
        },

        isMsgTextWithoutPlaceholder () {
            return this.msgText.indexOf(this.placeholderBegin) < 0;
        },
        msgTextBeforePlaceholder() {
            return this.msgText.substring(0,this.msgText.indexOf(this.placeholderBegin));
        },
        msgTextAfterPlaceholder() {
            return this.msgText.substring(this.msgText.indexOf(this.placeholderEnd) + this.placeholderEnd.length);
        },

        msgTextInPlaceholder() {
            return this.msgText.substring(this.msgText.indexOf(this.placeholderBegin) + this.placeholderBegin.length, this.msgText.indexOf(this.placeholderEnd));
        },
    },

    methods: {
        openDocPopup(code) {
            this.$emit("openDocPopup", code);
        }
    }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/MessageReceivedContent.vue